// MASAR landing page test IDs
export const MASAR = {
  // Navigation
  navLogo: "masar-nav-logo",
  navHowItWorks: "masar-nav-how-it-works",
  navServices: "masar-nav-services",
  navCoverage: "masar-nav-coverage",
  navFaq: "masar-nav-faq",
  navSupport: "masar-nav-support",
  navDownloadCta: "masar-nav-download-cta",
  mobileMenuToggle: "masar-mobile-menu-toggle",

  // Hero
  heroTitle: "masar-hero-title",
  heroCtaPrimary: "masar-hero-cta-primary",
  heroCtaSecondary: "masar-hero-cta-secondary",
  heroAppStore: "masar-hero-appstore",
  heroPlayStore: "masar-hero-playstore",

  // Sections
  sectionHowItWorks: "masar-section-how-it-works",
  sectionServices: "masar-section-services",
  sectionCoverage: "masar-section-coverage",
  sectionFeatures: "masar-section-features",
  sectionFaq: "masar-section-faq",
  sectionSupport: "masar-section-support",

  // FAQ items
  faqItem: (i) => `masar-faq-item-${i}`,

  // Contact form
  contactForm: "masar-contact-form",
  contactName: "masar-contact-name",
  contactEmail: "masar-contact-email",
  contactPhone: "masar-contact-phone",
  contactSubject: "masar-contact-subject",
  contactMessage: "masar-contact-message",
  contactSubmit: "masar-contact-submit",
  contactSuccess: "masar-contact-success",
  contactError: "masar-contact-error",
  contactEmailLink: "masar-contact-email-link",

  // Footer
  footer: "masar-footer",
  footerEmail: "masar-footer-email",
  footerDomain: "masar-footer-domain",
};
